(function(angular) {
    'use strict';
    
    // the new attribute I'm defining to have more control over whether a specific item
    // gets selected or not, even when an event occurs that would normally select the item
    var typeaheadSelectInterceptor = 'ap-typeahead-select-interceptor';

    // scope event I'm defining to allow for a search to be triggered
    // outside of just typing in search box
    var typeaheadSearchEvent = 'ap-typeahead-search';

    // property for other match that is not in the list of matches, used below
    var otherMatchProp = 'apOtherMatch';

    // This attribute will add a header element above the results in the popup element for typeahead
    // the popup element is normally a <ul> that has all of the results inside of it
    // if this attribute isn't used, then it will never add a header
    var typeaheadHeader = 'ap-typeahead-default-header';

    // This attribute will allow the user to select 'None' note: you will also need to add 'ap-typeahead-none-action'
    var typeaheadDisplayNone = 'ap-typeahead-display-none';

    // Default will result in an empty selection ex. ap-typeahead-none-action="vm.callNoneAction()"
    var typeaheadNoneAction = 'ap-typeahead-none-action';

    // name of new directive to trigger the typeahead on click
    var apTypeaheadSearchOnClick = 'apTypeaheadSearchOnClick';

    // property to store original event 'target' value
    var originalTargetProp = 'apTypeaheadOriginalTarget';

    // attribute to specify that if you change the model to a string with code, then it will trigger a search for that
    var apTypeaheadSearchOnModelUpdate = 'apTypeaheadSearchOnModelUpdate';

    angular.module('aprima-core-ui').decorator('uibTypeaheadPopupDirective', [
        '_',
        '$delegate',
        '$parse',
        'enableTypeaheadTrackBy',
        'findTypeahead', 
        'positionTypeaheadPopup',
        'setTypeaheadPopupHeight',
        'typeaheadPopupClass',
        uibTypeaheadPopupDecorator,
    ]);

    angular.module('aprima-core-ui').decorator('uibTypeaheadDirective', [
        '$delegate',
        '$document',
        uibTypeaheadDecorator,
    ]);

    angular.module('aprima-core-ui').directive(apTypeaheadSearchOnClick, [
        'ClickListenerService',
        apTypeaheadSearchOnClickDirective,
    ]);

    function uibTypeaheadPopupDecorator(
        _,
        $delegate,
        $parse,
        enableTypeaheadTrackBy,
        findTypeahead, 
        positionTypeaheadPopup,
        setTypeaheadPopupHeight,
        typeaheadPopupClass
    ) {

        var directive = $delegate[0];
        var compile = directive.compile;

        directive.compile = function(tElement) {
            var link = compile.apply(this, arguments);

            //the element that has typeahead on it
            var typeaheadElement = findTypeahead(tElement);
            enableTypeaheadTrackBy(tElement, typeaheadElement);
            typeaheadPopupClass.init(tElement, typeaheadElement);
            var header = typeaheadElement.attr(typeaheadHeader);
            if(header) {
                var headerElement = angular.element('<div class="dropdown-header li-aligned" ng-show="defaultHeader()">{{defaultHeader()}}</div>');
                tElement.prepend(headerElement);
            }

            var displayNone = typeaheadElement.attr(typeaheadDisplayNone);
            var noneAction = typeaheadElement.attr(typeaheadNoneAction);
            if(displayNone) {
                var noneElement = angular.element('<div class="li-item" ng-show="displayNone()" ng-click="noneAction()">None</div>');
                tElement.prepend(noneElement);
            }

            return function(scope, element) {
                // Fixes issue where you can click in the list of matches on a header or something
                // without trying to select a match
                // and the matches will still get reset
                element.on('click', stopPropagation);
                scope.$on('$destroy', function () {
                    element.off('click', stopPropagation);
                });
                
                if(header) {
                    scope.defaultHeader = function() {
                        // The default header should only be shown if we're displaying the default results.
                        var hasDefaultMatches = scope.matches && scope.matches[0] && scope.matches[0].model && scope.matches[0].model.isDefault;
                        if(hasDefaultMatches) {
                            // evaluate on outer parent scope because that is what typeahead would evaluate this attribute on
                            return scope.$parent.$parent.$eval(header);
                        }
                        return null;
                    };
                }

                if(displayNone) {
                    scope.displayNone = function() {
                        // evaluate on outer parent scope because that is what typeahead would evaluate this attribute on
                        return scope.$parent.$parent.$eval(displayNone);
                    };
                }

                if(noneAction) {
                    scope.noneAction = function() {
                        // evaluate on outer parent scope because that is what typeahead would evaluate this attribute on
                        return scope.$parent.$parent.$eval(noneAction);
                    };
                }

                var typeaheadNgModel = typeaheadElement.controller('ngModel');
                var triggerSearch = _.partial(typeaheadTriggerSearch, typeaheadNgModel);
                scope.triggerSearch = triggerSearch;

                var interceptor = typeaheadElement.attr(typeaheadSelectInterceptor);

                var selectInterceptor = function() { return true; };
                if(interceptor) {
                    var parsedInterceptor = $parse(interceptor);
                    selectInterceptor = function(item, evt) {
                        var interceptorArgs = {
                            $item: item,
                            $event: evt,
                            $triggerSearch: triggerSearch,
                        };
                        // evaluate on outer scope because that is what typeahead would evaluate this attribute on
                        return parsedInterceptor(scope.$parent.$parent, interceptorArgs);
                    };
                }

                scope.shouldSelect = selectInterceptor;

                // override the select function to use the interceptor provided by the typeaheadSelectInterceptor attr
                var parentSelect = scope.$parent.select;
                scope.$parent.select = function(activeIdx, evt) {
                    var match = scope.$parent.matches[activeIdx];
                    var item = match.model;

                    if(match.override || selectInterceptor(item, evt)) {
                        return parentSelect.apply(this, arguments);
                    }
                    else if(evt && evt.stopPropagation) {
                        evt.stopPropagation();
                    }
                };

                scope.selectOther = function(obj, evt, override) {
                    scope.$parent.matches[otherMatchProp] = {
                        id: otherMatchProp,
                        label: '',
                        model: obj,
                        override: !!override,
                    };
                    scope.selectMatch(otherMatchProp, evt);
                    delete scope.$parent.matches[otherMatchProp];
                };

                link.apply(this, arguments);

                setTypeaheadPopupHeight(scope, element, typeaheadElement);
                positionTypeaheadPopup(scope, element, typeaheadElement);
            };
        };

        return $delegate;
    }

    function uibTypeaheadDecorator(
        $delegate
    ) {

        var directive = $delegate[0];

        var directiveController = directive.controller;
        directive.controller = [
            '$attrs',
            '$controller',
            '$document',
            '$element',
            '$scope',
            '$transclude',
            uibTypeaheadController,
        ];

        var compile = directive.compile;
        directive.compile = function() {
            var link = compile.apply(this, arguments);

            return function(scope, element, attrs, ctrls) {
                var ngModel = ctrls[0];
                var triggerSearch = _.partial(typeaheadTriggerSearch, ngModel);

                link.apply(this, arguments);

                // Setup an event handler to allow a search to be triggered manually
                scope.$on(typeaheadSearchEvent, function (e, selector, value) {
                    if (element.is(selector)) {
                        triggerSearch(value);
                        element.focus();
                    }
                });

                // if this attribute evaluates to truthy, then add a formatter that will trigger the search
                // if the modelValue is a string
                if(scope.$eval(attrs[apTypeaheadSearchOnModelUpdate])) {
                    var typeaheadFormatter = ngModel.$formatters.pop();
                    ngModel.$formatters.push(createSearchFormatter(typeaheadFormatter));
                }

                function createSearchFormatter(originalFormatterFn) {
                    return searchFormatter;

                    function searchFormatter(modelValue) {
                        if(modelValue && angular.isString(modelValue)) {
                            triggerSearch(modelValue);
                            return modelValue;
                        }
                        return originalFormatterFn(modelValue);
                    }
                }
            };
        };

        return $delegate;


        function uibTypeaheadController(
            $attrs,
            $controller,
            $document,
            $element,
            $scope,
            $transclude
        ) {
            var domElement = $element[0];
            var documentElement = $document[0].documentElement;

            // Register these listeners in this order, because the directiveController
            // registers a 'click' listener on the document as well.
            // Surrounding that listener with these 2 will allow us to control how the directive controller
            // handles the event, and then cleanup anything extra afterwards.
            $document.on('click', documentClickHandlerStart);
             var controller = $controller(directiveController, {
                $attrs: $attrs,
                $element: $element,
                $scope: $scope,
                $transclude: $transclude,
            });
            $document.on('click', documentClickHandlerEnd);
            

            $scope.$on('$destroy', function () {
                $document.off('click', documentClickHandlerStart);
                $document.off('click', documentClickHandlerEnd);
            });

            return controller;


            // This function is setup to not allow clicks in a separate modal to close out of typeahead matches,
            // since the modal is supposed to be sort of separate from the current page.
            function documentClickHandlerStart(event) {
                var target = event && event.target;
                if (!target) {
                    return;
                }

                if (target === documentElement) {
                    // If the click is on the documentElement, then it is most likely because
                    // the mouse was dragged outside the screen.
                    // Set the target to be the current typeahead element, so the matches won't get closed.
                    event[originalTargetProp] = event.target;
                    event.target = domElement;
                    return;
                }


                // If the click is inside a modal, and the modal doesn't contain this typeahead,
                // then set the target to be the current typeahead element, so the matches won't get closed.
                var targetModalContainer = $(target).parents('.modal')[0];
                if (targetModalContainer && !$.contains(targetModalContainer, domElement)) {
                    event[originalTargetProp] = event.target;
                    event.target = domElement;
                    return;
                }
            }

            function documentClickHandlerEnd(event) {
                var originalTarget = event && event[originalTargetProp];
                if(originalTarget) {
                    // if the target was changed by the handler above, then reset it back to its original value,
                    // and cleanup the originalTargetProp to avoid side effects
                    event.target = originalTarget;
                    delete event[originalTargetProp];
                }
            }
        }
    }

    function apTypeaheadSearchOnClickDirective(
        ClickListenerService
    ) {

        var directive = {
            restrict: 'A',
            link: link,
        };

        return directive;

        function link(
            scope,
            elem,
            attrs
        ) {
            var dereg = ClickListenerService.register(elem, clickHandler);

            // prevent default of mousedown event on this element so it doesn't get focused, and the
            // typeahead input box can be focused instead
            elem.on('mousedown', preventDefault);

            scope.$on('$destroy', function () {
                elem.off('mousedown', preventDefault);
                dereg();
            });

            function clickHandler() {
                var selector = scope.$eval(attrs[apTypeaheadSearchOnClick]);
                var value = scope.$eval(attrs[apTypeaheadSearchOnClick + 'Value']);

                scope.$broadcast(typeaheadSearchEvent, selector, value);
            }

            function preventDefault(event) {
                if(event && event.preventDefault) {
                    event.preventDefault();
                }
            }
        }
    }

    function typeaheadTriggerSearch(ngModel, value) {
        ngModel.$$lastCommittedViewValue = null;
        ngModel.$setViewValue(value || ngModel.$viewValue);
        ngModel.$render();
    }

    function stopPropagation(event) {
        if(event && event.stopPropagation) {
            event.stopPropagation();
        }
    }
    
})(window.angular);
